import { render } from "./PatientForm.vue?vue&type=template&id=25d77065&ts=true"
import script from "./PatientForm.vue?vue&type=script&lang=ts"
export * from "./PatientForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/Patient/PatientForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "25d77065"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('25d77065', __exports__)) {
    api.reload('25d77065', __exports__)
  }
  
  module.hot.accept("./PatientForm.vue?vue&type=template&id=25d77065&ts=true", () => {
    api.rerender('25d77065', render)
  })

}


export default __exports__